import { atom, useAtom } from 'jotai';

const timerExpiredAcceptedAtom = atom(true);

export const useTimerAcceptedAtom = () => {
	const [timerExpiredAccepted, setTimerExpiredAccepted] = useAtom(timerExpiredAcceptedAtom);

	return {
		setTimerExpiredAccepted,
		timerExpiredAccepted
	};
};
